export class AdministracionObjetivos {
    id: number;
    OfFactId: number;
    year: number;
    month: number;
    importeObjetivo: number;
    importeReal: number;
    createdBy: string;
    updatedBy: string;
    updatedDate: string;
    createdDate: string;
    createdByName: string;
    updatedByName: string;
}
